module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/transform.js
// module id = 52
// module chunks = 35783957827783 114276838955818 199194594041642 201052475613007